import {useDispatch, useSelector} from "react-redux";
import {listConfigSelector, rxShowCategoryEditor, rxToggleInactiveCategories, selectAllCategories} from "../../../../slices/categoriesSlice";
import {useTranslation} from "react-i18next";
import {useMemo} from "react";
import {selectAllTransactions} from "../../../../slices/transactionsSlice";

const useSettingsCategories = () => {
  const dispatch = useDispatch();

  const {t} = useTranslation("settings_categories");

  const {inactiveCategories} = useSelector(listConfigSelector);

  const transactionCategories = useSelector(selectAllCategories);
  const allTransactions = useSelector(selectAllTransactions);

  const showCategoryEditor = (mode, category) => dispatch(rxShowCategoryEditor({mode, category}));

  const toggleInactiveCategories = () => {
    dispatch(rxToggleInactiveCategories());
  }

  const groups = useMemo(() => {
    const g = {};

    transactionCategories.filter(category => inactiveCategories || category.active).forEach(category => {
      if (!g[category.groupName]) {
        g[category.groupName] = {
          groupName: category.groupName,
          categories: []
        };
      }

      g[category.groupName].categories.push(category);
    });

    Object.values(g).forEach(group => group.categories = group.categories.toSorted((a, b) => a.name.localeCompare(b.name)));

    return Object.values(g).toSorted((a, b) => a.groupName.localeCompare(b.groupName));
  }, [transactionCategories, inactiveCategories]);

  const transactionsCount = useMemo(() => {
    const res = {};

    transactionCategories.forEach(cat => res[cat.id] = 0);

    allTransactions.forEach(t => res[t.category]++);

    return res;
  }, [transactionCategories, allTransactions]);

  return {
    t,
    transactionCategories,
    transactionsCount,
    groups,
    showCategoryEditor,
    inactiveCategories,
    toggleInactiveCategories
  };
};

export default useSettingsCategories;
